"use client"
import styles from "../../../../styles/finder/finder.module.scss"
import SText from "../../Text/SText"
import { ChangeEvent, useEffect, useState } from "react"
import { useUserStore } from "../store/finder_store"
import ContactForm from "../ContactForm"
import { useTranslations } from "next-intl"
import StyledText from "../../../typography/typography-component"
import skColors from "../../../../styles/skColors"
import TextInputField from "../../TextInputField/TextInputField"
import ModalComponent from "../../ModalComponent/ModalComponent"
import Checkbox from "../../checkbox/checkbox"
import { supportOptions } from "../store/finder_store"
import Image from "next/image"

const Step2b = ({ onDisabledChange }: { onDisabledChange: (value: boolean) => void }) => {
  const t = useTranslations("index.finder")
  const { firstName, lastName, mail, confirmDataUsage, plz, setPLZ, phone, supportOptions: selectedSupportOptions, toggleSupportOption } = useUserStore()
  const [activeInfo, setActiveInfo] = useState<"reimbursement" | "selfPayment" | "switchInsurance" | null>(null)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    if (/^\d*$/.test(newValue)) {
      setPLZ(newValue)
    }
  }

  const infoContent = {
    reimbursement: {
      title: t("step2b.options.reimbursement"),
      text: t("step2b.reimbursementText"),
    },
    selfPayment: {
      title: t("step2b.options.selfPayment"),
      text: t("step2b.selfPaymentText"),
    },
    switchInsurance: {
      title: t("step2b.options.switchInsurance"),
      text: t("step2b.switchInsuranceText"),
    },
  }

  useEffect(() => {
    console.log("last", lastName.length)
    console.log("mail", mail.length)
    console.log("confirm", confirmDataUsage)
    onDisabledChange(
      firstName.length === 0 ||
        lastName.length === 0 ||
        mail.length === 0 ||
        plz.length != 5 ||
        phone.length === 0 ||
        !confirmDataUsage
    )
  }, [onDisabledChange, lastName, mail, confirmDataUsage, plz, phone])

  const optionItems = [
    { key: supportOptions.selfPayment, label: t("step2b.options.selfPayment") },
    { key: supportOptions.switchInsurance, label: t("step2b.options.switchInsurance") },
  ] as const

  return (
    <div className={styles.step2Content}>
      <StyledText style={{ paddingBottom: "16px" }} color={skColors.turquoise[600]} variant={"h3"}>
        {t("step1.title")}
      </StyledText>
      <div className={styles.successSection} style={{ marginBottom: "32px" }}>
        <StyledText as="p" variant="pRegular">
          {t("step2b.title")} {" "}
          <b>
            {t("step2b.title2")}
          </b>
        </StyledText>
        <div className={styles.infoCheckboxTiles}>
        <StyledText as="p" variant="pRegular" style={{ marginBottom: "8px" }}>
          {t("step2b.supportQuestion")}
        </StyledText>
          {optionItems.map((item) => (
            <div key={item.key} className={styles.infoCheckboxTile}>
              <div className={styles.infoCheckboxTileContent}>
                <Checkbox
                  id={item.key}
                  checked={selectedSupportOptions.includes(item.key)}
                  onChange={() => toggleSupportOption(item.key)}
                />
                <StyledText as="label" htmlFor={item.key} variant="pRegular">
                  {item.label}
                </StyledText>
              </div>
              <button
                type="button"
                className={styles.infoTileButton}
                aria-label={`${item.label} Informationen anzeigen`}
                onClick={() => setActiveInfo(item.key)}
              >
                <Image src="/svg/help_circle.svg" alt="" width={20} height={20} aria-hidden="true" />
              </button>
            </div>
          ))}
        </div>

        <StyledText variant={"pRegular"} style={{ marginTop: "8px" }}>
          {t("step2b.successText")} 
        </StyledText>
      </div>

      <ModalComponent
        isOpen={activeInfo !== null}
        closeModal={() => setActiveInfo(null)}
        width={460}
        style={{ padding: "28px 24px 20px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <StyledText as="h4" variant="h4" color={skColors.darkgreen[600]}>
            {activeInfo ? infoContent[activeInfo].title : ""}
          </StyledText>
          <StyledText as="p" variant="pRegular">
            {activeInfo ? infoContent[activeInfo].text : ""}
          </StyledText>
        </div>
      </ModalComponent>

      <ContactForm></ContactForm>
    </div>
  )
}

export default Step2b
